<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RJQzvb/tc-custom/9781398489028.jpg?1718170066318" alt="This image is the cover for the book A Mere Shepherd Boy – Book 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Mere Shepherd Boy – Book 1
      </h1>
      <p class="bookDescription body article font2">
        <p>The year was 1,000 BC. Life was fraught with danger. Drought, famine, and sickness were a constant threat. At any moment an enemy could invade. In a little hilltop village, a child was born, the youngest of a tribe of brothers. He was destined to become one of the best-known names in human history. As a child he knew nothing of this. Yet he dreamed! And as he led his father’s sheep through the wild pastures he looked to the heavens, played his harp, and lifted his voice in spontaneous song. There were predators in those hills, but he was unafraid and full of courage, as if protected from all harm. A natural leader, he won the loyalty and admiration of the other boys in town. He drilled them in war-games, and they shared many adventures. These childhood companions remained faithful to him throughout all the seasons of his life. Through thick and thin they followed him, because of... that special something... that capacity to inspire and to lead, which seemed to come so naturally to him. This is the story of his early years. It lays the foundation - culturally, socially and geographically - for the epic life-journey which lay ahead. His legacy would last forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Peter Thomas-Hall
      </h2>
      
      <p class="authorDescription body article">Mike Thomas-Hall grew up in Wales in the Rhondda Valley, but he never met Rhondda. Just as well because in Sydney, Australia, he met Belinda and she was an answer to a prayer. Four sons and 50 years later, they are still very grateful for each other. They live in the lush hills of the Tweed Valley in New South Wales, and you are very welcome to drop in.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17742694